module.exports = __webpack_public_path__ + "img/indian-rupee-sign.d92486dc.svg";